<template>
  <footer class="bg-light footer">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-3">

          <div class="footer__left-side">
            <div class="footer__left-side__logo">
              <img src="../assets/images/black-logo.png" alt="Footer logo">
            </div>

            <div class="footer__left-side__socials">
              <SocialLinks color="#1E2532" />
            </div>
          </div>

          <p class="footer__text">{{ $t('header.title') }}</p>

        </div>

        <div class="col-md-9">
          <ul class="footer__links">

            <li
                v-for="(link, index) in links"
                :key="'bottom navbar links' + index"
                class="footer__links__item"
            >
              <router-link :to="{ name: link.name, hash: link.hash }">
                {{ $t(`site_links.${link.title || link.name}`) }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <hr class="d-none d-md-block">

      <div class="row contacts d-none d-md-flex">

        <div class="col-md-4 contacts__info">
          <LocationIcon class="me-2 " />
          {{ $t('footer.address') }}
        </div>

        <div class="col-md-4 contacts__info">
          <MessageIcon class="me-2" />
          {{ CALL_CENTER_PHONE_NUMBER }}
        </div>

        <div class="col-md-4 contacts__info">
          <PhoneIcon class="me-2" />
          {{ EMAIL }}
        </div>

      </div>

      <div class="row bottom-section align-items-center">

        <div class="col-md-6 bottom-section__user-info" ref="counter"></div>

        <div class="col-md-6 bottom-section__company-info d-md-block d-none">
          <p>{{ $t('footer.site_copyright') }}</p>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
import SocialLinks from '@/components/SocialLinks';
import navLinks from '@/mixins/nav-links.mixin';
import LocationIcon from '@/components/svg/LocationIcon';
import MessageIcon from '@/components/svg/MessageIcon';
import PhoneIcon from '@/components/svg/PhoneIcon';
import { CALL_CENTER_PHONE_NUMBER, EMAIL } from '@/utils/constants';

export default {
  name: 'Footer',
  components: {
    SocialLinks,
    LocationIcon,
    MessageIcon,
    PhoneIcon,
  },
  mixins: [navLinks],
  data: () => ({
    EMAIL,
    CALL_CENTER_PHONE_NUMBER,
    activeUser: 0,
    visitsPerDay: 0,
  }),
  methods: {},
  mounted() {
    setTimeout(() => {
      const clonedCounter = document.querySelector('.counter').cloneNode(true);
      clonedCounter.style.visibility = 'unset';
      clonedCounter.style.pointerEvents = 'unset';

      const counterContainer = this.$refs.counter;

      counterContainer?.prepend(clonedCounter);

    }, 300);
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/mixins/_font.scss";

.footer {
  padding: 60px 0;

  @media (max-width: $mobile) {
    padding: 30px 0;
  }

  hr {
    margin: 0 0 24px 0;
    background-color: #DEDEDE;
    height: 2px;
  }

  &__left-side {
    @media screen and (max-width: $mobile) {
      display: flex;
      justify-content: space-between;
    }

    &__logo {
      margin-bottom: 16px;
    }

    &__socials {
      display: none;

      @media screen and (max-width: $mobile) {
        display: block;
      }
    }
  }

  &__text {
    @include font($size: 18px, $lineHeight: 25px);
    margin-bottom: 24px;
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0 0 0 125px;

    @media screen and (max-width: $mobile) {
      flex-direction: column;
      border-top: 1px solid rgba(30, 30, 30, 0.08);
      padding: 24px 0 0 0;
      margin: 0;
    }

    &__item {
      margin-bottom: 6px;

      &:not(:last-child) {
        margin-right: 55px;
      }

      a {
        text-decoration: none;
        @include font($size: 18px, $lineHeight: 49px, $color: rgba(30, 37, 50, 0.9));

        &:hover {
          color: $main;
        }

        &.router-link-active {
          color: $main;
        }
      }
    }
  }

  .contacts {
    &__info {
      @include font(18px, 500, 25px);

      @media (max-width: $mobile) {
        margin-bottom: 1rem;
      }

    }
  }

  .bottom-section {
    margin-top: 58px;

    @media (max-width: $mobile) {
      margin: 0;
    }

    &__user-info {
      display: flex;
      align-items: center;

      p {
        @include font(14px, 600, 15px);
        margin: 0;

        &:first-child {
          margin-right: 1rem;
        }

        span {
          @include font(16px, 600, 18px, $main)
        }
      }
    }

    &__company-info {
      text-align: right;

      p {
        @include font(16px, 600, 20px, #989898);
        margin: 0;
      }
    }
  }
}
</style>